import React from "react";

export default function Menu() {
  return (
    <div
      className="menuContainer primary white"
    >
      <div className="menuExchange">TYPE</div>
      <div className="menuExchange">MSG</div>
      <div className="menuExchange">COMMENT</div>
      <div className="menuExchange">DATE</div>
    </div>
  );
}
